import React, { useEffect, useState } from "react";
import { Tabs, Table, Button, Checkbox, Dialog, Input, Message } from "@jdcfe/legao";
import { Modal } from 'antd';
import { observer } from "mobx-react-lite";
import useStore from "stores";
import qs from "qs";
import { modifyIpWriteList, queryAuthPackList } from "utils/api";
import NoPermission from "./../NoPermission";
import "./style.scss";
import { nodeModuleNameResolver } from "typescript";

const TrafficPermissionContent = observer(() => {
  let refInput,refError;
  const tableColumn = [
    {
      title: "白名单 IP地址",
      dataIndex: "ip",
      key: "2",
      width: 300,
    }
  ];
  const [empty, setEmpty] = useState(null);
  const { trafficPermissionStore } = useStore();
  const [ tableData, setTableData ] = useState([]);
  const [wlist, setWList] = useState([]);
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  useEffect(() => {
    if (empty == null) {
      queryAuthPackList({
        appKey: query.appKey,
        openStateType: null,
      }).then((res) => {
        setEmpty(!!res.data.result);
        if(res.data.result!=null){
          if(!empty) {

            trafficPermissionStore.queryTrafficPermissionList({
              appKey: query.appKey,
            }).then(res=>{
              let list=[];
              console.log(res.data.result != null || !!res.data.result)
              if(res.data.result != null || !!res.data.result) {
                 list = res.data.result.ipWhiteList.map((item, index) => {
                  return {
                    ip: item,
                    key: index
                  };
                });
              }
              setTableData(list);
            });
          }         
        }
      });
    }
  
  }, [empty]);
  /*eslint-disable*/
  const handleChange = (index) => {
    console.log(index)
  };

  const ipWriteList = (list,cb = null) => {
    modifyIpWriteList({
      appKey: query.appKey,
      ipWhiteList: list
    }).then(res => {
      if(res.data.resultCode == '0000') {
        cb != null && cb();
      } else {
        Message.showMsg({
          showIcon: true,
          type: "wrong",
          description: res.data.resultMessage,
          autohide: true,
          closable: false,
          onClose: () => {},
        });
      }
    })
  }

  const RenderAdd = ({value}) => {
    const [textval, setTextVal] = useState(value);
    const handleTextAreaChange = (e) => {
      setTextVal(e.target.value);
    }
    return (<div className="add-wrapper">
      <i className="required">*</i><span className="text">IP 地址</span>
      <Input.TextArea cols="30" rows="10" value={textval}  ref={(ref) => {refInput = ref}} onChange={(e) => {handleTextAreaChange(e)}}/>
      <p className="error" ref={(ref) => (refError = ref)}>请输入正确的IP地址</p>
    </div>)
  }

  const add = (cb) => {
    let pattern = /((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[0-1]?\d{1,2})){3}/;
    let val = refInput.props.value.split('\n');
    if(refInput.props.value) {
      for(let i = 0; i < val.length; i++) {
        if(!pattern.test(val[i])) {
          refError.style.display = 'block';
          return;
        }
      }
    }
    
    ipWriteList(refInput.props.value ? val : [],() => {
      cb();
    });
  }

  const addWhiteList = () => {
    const binContact = Modal.confirm({
      // title: `设置白名单`,
      content: <RenderAdd value={[...trafficPermissionStore.list].join("\n")} />,
      title: <div>设置白名单<span className="desc">【注】换行设置多个IP</span></div>,
      width: 700,
      zIndex: 99,
      okText: '提交',
      cancelText: '取消',
      closable: true,
      onOk() {
        log('VopOpenConsole_1611892618710','13')
        add(() => {
          location.reload();
        });
      },
      onCancel() {
        log('VopOpenConsole_1611892618710','14')
        // binContact.close()
      },
      // actions: [
      //   {
      //     text: "提交",
      //     onClick: () => {
      //       log('VopOpenConsole_1611892618710','13')
            
      //       add(() => {
      //         location.reload();
      //       });
      //     },
      //     className: "sure",
      //     styleType: "primary",
      //     autoClose: false,
      //   },
      //   {
      //     text: "取消",
      //     onClick: () => {
      //       log('VopOpenConsole_1611892618710','14')

      //       binContact.close()
      //     },
      //     className: "cancel",
      //     styleType: "",
      //   },
      // ],
      wrapClassName: "white_dialog",
    });
  }

  return (
    <div className="subscribe_content">
      {empty&&trafficPermissionStore.list != null ? (
        !trafficPermissionStore.list.length ? (
          <div className="no_subscribe">
            <NoPermission content="尚未增加白名单，配置白名单后可以访问接口" isshow={false}/>
            <div className="add-btn">
              <Button styleType="primary" onClick={() => {addWhiteList()}}  clstag="pageclick|keycount|VopOpenConsole_1611892618710|12">
                <span className={`lg-btn-text`}>设置白名单</span>
              </Button>
            </div>
          </div>
        ) : (
          <Tabs
            className="tabs-wrapper"
            type="line"
            onChange={(i) => {
              handleChange(i);
            }}
          >
            <Tabs.Panel label="白名单管理">
              <div className="search-wrapper">
                  <Button styleType="primary" onClick={() => {addWhiteList()}}>
                    <span className={`lg-btn-text`}>设置白名单</span>
                  </Button>
              </div>
              <div className="subscribe-table">
                <Table
                  columns={tableColumn}
                  data={tableData}
                  emptyText={"暂无数据"}
                />
              </div>
            </Tabs.Panel>
          </Tabs>
        )
      ) : (
        <div className="no_subscribe">
          <NoPermission content="应用未绑定合同，无法查看流量权限" isshow={false}/>
        </div>
      )}
    </div>
  );
});

export default TrafficPermissionContent;
